module.exports = __webpack_public_path__ + "img/crm.36a5606.png";